export const STATUS_MAP: Record<string, UploadStatus> = {
  uploading: 'uploading',
  uploaded: 'uploaded',
  importing: 'importing',
  transcribing: 'transcribing',
  analyzing: 'analyzing',
  done: 'done',
  failed: 'error',
}

export type ProcessingStage = 'upload' | 'import' | 'transcribe' | 'analyze' | 'done'

export type UploadStatus =
  | 'pending'
  | 'uploading'
  | 'uploaded'
  | 'importing'
  | 'transcribing'
  | 'analyzing'
  | 'done'
  | 'error'

export interface UploadItem {
  id: string
  fileName: string
  status: UploadStatus
  jobId: string
  contactLogId?: string
  error?: string
  uploadProgress?: number
}

export interface FileUpload {
  id: string
  jobId: string
  fileName: string
  progress: number
  status: 'uploading' | 'uploaded' | 'error'
  error?: string
}

export interface FileUploadState {
  ids: string[]
  files: Record<string, FileUpload>
  progress: number
  completed: number
}
